module.exports = __webpack_public_path__ + "img/ic_apple_pay.0df95b04.svg";